export default {
  blank: () => import("/vercel/path0/layouts/blank.vue").then(m => m.default || m),
  default: () => import("/vercel/path0/layouts/default.vue").then(m => m.default || m)
}